var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"welcome-margin"},[_c('v-col',{staticClass:"section-header",attrs:{"cols":"12"}},[_vm._v(" Welcome "),_c('a',{class:{
          'dark-name': _vm.$vuetify.theme.dark,
          'light-name': !_vm.$vuetify.theme.dark
        }},[_vm._v(" "+_vm._s(_vm.currentUser.firstName)+" "+_vm._s(_vm.currentUser.lastName)+" ")])]),_c('v-col',{attrs:{"cols":"12"}},[(_vm.isLead)?_c('Home_Lead'):(_vm.isSupervisor)?_c('Home_Supervisor'):(_vm.isManager)?_c('Home_Manager'):(_vm.isTechAdvisor)?_c('Home_Tech'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }